import { Block } from 'webiq.boilerplate'

export default class LpProgress extends Block {
	static title = 'lp-progress'

	init() {
        this.progressBar = this.getElement('bar')

        this.updateProgress()

        window.addEventListener('scroll', () => this.updateProgress())
    }

    updateProgress() {
        const pageSize = document.querySelector('body').getBoundingClientRect()
        const browserHeight = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight

        const percentage = ((Math.abs(pageSize.y) + browserHeight) / pageSize.height) * 100

        this.progressBar.style.width = parseInt(percentage) + "%"
    }
}
